var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { SiteHeaderLayout } from './site-header-layout';
import { SliceLayout } from './slice-layout';
import { classNames } from '../../utils';
import { useComponentColor } from '../../hooks/use-component-color';
import { get } from 'lodash';
import { useSiteHeader } from '../../hooks/use-site-header';
var cls = classNames('entity-title-header');
export var EntityTitleHeaderDefaultProps = {
  showOverlayGradient: false,
  isInverted: true
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    background-repeat: no-repeat;\n    background-position: center center;\n\n    ", "\n\n    ", "\n\n  "], ["\n    display: flex;\n    flex-direction: column;\n    background-repeat: no-repeat;\n    background-position: center center;\n\n    ", "\n\n    ", "\n\n  "])), function (_a) {
    var _color = _a._color,
        _backgroundColor = _a._backgroundColor;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      color: ", ";\n      background-color: ", ";\n    "], ["\n      color: ", ";\n      background-color: ", ";\n    "])), _color, _backgroundColor);
  }, function (_a) {
    var _backgroundImage = _a._backgroundImage,
        _overlayColor = _a._overlayColor;
    return _backgroundImage && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      background-image: ", " url(", ");\n      background-size: cover;\n    "], ["\n      background-image: ", " url(", ");\n      background-size: cover;\n    "])), _overlayColor && "linear-gradient(to bottom, " + _overlayColor + " 0%, " + _overlayColor + " 100%),", _backgroundImage);
  })
});
var SiteHeaderStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    flex-grow: 1;\n    color: inherit;\n    display: flex;\n    justify-self: stretch;\n    flex-direction: column;\n    justify-content: center;\n  "], ["\n    flex-grow: 1;\n    color: inherit;\n    display: flex;\n    justify-self: stretch;\n    flex-direction: column;\n    justify-content: center;\n  "])))
});
var TitleStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-size: 2em;\n    line-height: 1.15em;\n    font-weight: 500;\n    color: inherit;\n    margin: ", " 0;\n  "], ["\n    font-size: 2em;\n    line-height: 1.15em;\n    font-weight: 500;\n    color: inherit;\n    margin: ", " 0;\n  "])), theme.UNIT(4)),
  tablet: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    font-size: 2.25em;\n    margin: ", " 0;\n  "], ["\n    font-size: 2.25em;\n    margin: ", " 0;\n  "])), theme.UNIT(6)),
  desktop: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    font-size: 2.5em;\n    margin: ", " 0;\n  "], ["\n    font-size: 2.5em;\n    margin: ", " 0;\n  "])), theme.UNIT(8))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  SiteHeader: styled(SiteHeaderLayout)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), SiteHeaderStyles),
  Body: styled(SliceLayout)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Title: styled.h1(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles)
};
export var EntityTitleHeader = function EntityTitleHeader(props) {
  var className = props.className,
      children = props.children,
      entity = props.entity,
      isInverted = props.isInverted,
      overlayColor = props.overlayColor,
      backgroundImage = props.backgroundImage,
      siteHeaderProps = __rest(props, ["className", "children", "entity", "isInverted", "overlayColor", "backgroundImage"]);

  var title = entity.title || entity.name;
  var backgroundColor = useComponentColor({
    cls: cls,
    prop: props.backgroundColor,
    isInverted: isInverted,
    fallbacks: ['light-background', 'light-brand', 'light'],
    invertedFallbacks: ['dark-background', 'dark-brand', 'dark']
  });
  var color = useComponentColor({
    cls: cls,
    prop: props.color,
    isInverted: isInverted,
    fallbacks: ['dark'],
    invertedFallbacks: ['light']
  });
  var SiteHeader = useSiteHeader().component;
  var bg = get(backgroundImage, 'image.url', null);
  return React.createElement(My.Container, {
    _color: color,
    _overlayColor: overlayColor,
    _backgroundImage: bg,
    _backgroundColor: backgroundColor,
    className: cls.name(className)
  }, React.createElement(SiteHeader, __assign({
    maxLogoHeight: 84,
    useLogoVerticalOffsets: false,
    variant: "overlay"
  }, siteHeaderProps)), React.createElement(My.Body, {
    variant: 'boundary',
    boundary: "content"
  }, title && React.createElement(My.Title, null, title), children));
};
EntityTitleHeader.defaultProps = EntityTitleHeaderDefaultProps;
EntityTitleHeader.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;